import {useState,useEffect,useContext} from 'react'
import {  Link, useFetcher } from 'react-router-dom';
import { getAll } from '../../Data/Utils';
import { buildItemsList,getTlvLink } from '../../Data/GeneralFanction';
import { LanguageContext } from '../../context';
import './Banner.css'
import { isMobile } from 'react-device-detect';


const Banner = () => {

    const [ bannerItem,setBannerItem]=useState({Title:'',mainPicture_ModernView:{Value:'../../Images/Banner/campain-default.jpg'}});
    const [bgStyle,setBgStyle]= useState('right');
    const [bgUrl,setBgUrl]= useState('right');
    const { language } = useContext(LanguageContext);
    

    useEffect(()=>{
    const getBanner = async () => {
      var webUrl= window.srcSiteUrl;
            
      if(language=="en")
        webUrl=webUrl+"/"+language;
        var apiUrl=config.apiUrl;
        const bannerList=config.lists.banner.name; 
        const view=config.lists.banner.view;
        let { data: bannerData } = await getAll(`${webUrl}${apiUrl}?listName=${bannerList}&view=${view}`);
        var x=buildItemsList(bannerData);
        for (var i=0;i<x.length;i++){
          if(x[i].longURL.Value !== ''){
              x[i].tlvLink = getTlvLink(x[i].longURL.Value);
          }         
        }

        var rendition="?RenditionID=";
        if(isMobile){
          rendition+="6";
        }
        else{
          rendition+="5";
        }


        if(x[0].mainPicture_ModernView.Value!=null)
          setBgUrl(x[0].mainPicture_ModernView.Value.indexOf(',')>-1?x[0].mainPicture_ModernView.Value.substring(0,x[0].mainPicture_ModernView.Value.indexOf(','))+rendition:x[0].mainPicture_ModernView.Value+rendition);
        setBannerItem(x[0]);
    };
    var config = require('../../config.json');

    setBgUrl(bannerItem.mainPicture_ModernView);
    getBanner();

    if(isMobile){
      setBgStyle('bottom');
    }
    else{
      if(language=="en")
        setBgStyle('left')
    }
    

    },[language]);

  return (
    <div className='banner-container' role="banner">
      
      {/* { 
        banner.map((b,i)=>{ */}
        
          <div className='compaine-banner' style={{backgroundImage:`linear-gradient(to ${bgStyle}, transparent, rgba(0, 0, 0, 0.65)), url(${bgUrl})`}} >
            <div className='link-container'>
             
                {
                  bannerItem.tlvLink!=undefined && bannerItem.tlvLink.hasVal && 
                  <Link to={bannerItem.tlvLink.Url}> <h2>{bannerItem.tlvLink.Caption}</h2></Link>
                }
                {
                  bannerItem.tlvLink==undefined || !bannerItem.tlvLink.hasVal && <h2>{bannerItem.Title.Value}</h2>
                }
                  
              
            </div>
          </div>
     
      {/* })
        
      } */}
  </div>
  )
}

export default Banner